/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rules_Seo_Tournament_DescriptionInputs */



/**
* | output |
* | --- |
* | "Read the official Riftbound tournament rules and event policy." |
*
* @param {Rules_Seo_Tournament_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const rules_seo_tournament_description = /** @type {((inputs?: Rules_Seo_Tournament_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rules_Seo_Tournament_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lies die offiziellen Riftbound-Turnierregeln und Veranstaltungsrichtlinien.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Consultez les règles de tournoi officielles de Riftbound et la politique des événements.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("阅读 Riftbound 官方赛事规则与活动政策。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("閱讀 Riftbound 官方賽事規則與活動政策。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Riftbound 공식 대회 규정과 이벤트 정책을 확인하세요.")
	return /** @type {LocalizedString} */ ("Read the official Riftbound tournament rules and event policy.")
});